// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sub Admin: full-width list */
.dashboard-body .dashboard-activity-section {
  width: 100%;
  min-width: 0;
}

.dashboard-body .dashboard-content-inner {
  width: 100%;
  min-width: 0;
}

.dashboard-body .table-wrap {
  width: 100%;
  overflow-x: auto;
}

.dashboard-body .data-table {
  width: 100%;
  min-width: 600px;
  table-layout: auto;
}

/* Sub Admin: header with action button */
.dashboard-activity-header--with-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.dashboard-activity-header__left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: inherit;
  border: none;
  border-radius: var(--radius);
  cursor: pointer;
  transition: background 0.2s, opacity 0.2s;
}

.btn i {
  font-size: 0.8rem;
}

.btn-primary {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
}

.btn-primary:hover {
  opacity: 0.95;
}

.btn-secondary {
  background: var(--main-bg);
  color: var(--text);
  border: 1px solid var(--border);
}

.btn-secondary:hover {
  background: var(--border);
}

/* Modal */
.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  animation: modalFadeIn 0.2s ease;
}

@keyframes modalFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal {
  background: var(--card-bg);
  border-radius: var(--radius);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 440px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: modalSlideIn 0.25s ease;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--border);
}

.modal-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: var(--text);
}

.modal-close {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: var(--radius);
  background: transparent;
  color: var(--text-muted);
  font-size: 1.1rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.modal-close:hover {
  background: var(--main-bg);
  color: var(--text);
}

.modal-body {
  padding: 1.5rem;
  overflow-y: auto;
}

.modal-error {
  padding: 0.65rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.85rem;
  color: #b91c1c;
  background: #fef2f2;
  border-radius: var(--radius);
}

.modal-field {
  margin-bottom: 1rem;
}

.modal-field label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text);
}

.modal-field input,
.modal-field select {
  width: 100%;
  padding: 0.65rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: #fff;
  color: var(--text);
}

.modal-field input:focus,
.modal-field select:focus {
  outline: none;
  border-color: #14b8a6;
}

/* Multiple roles: checkboxes */
.roles-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
  padding: 0.75rem 0;
}

.roles-checkbox-label {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.roles-checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #0f766e;
  cursor: pointer;
}

.subadmin-table__roles {
  max-width: 220px;
  font-size: 0.875rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border);
}

.modal-footer .btn {
  min-width: 100px;
}

/* Sub Admin table: action buttons */
.subadmin-table-wrap {
  width: 100%;
  overflow-x: auto;
}

.subadmin-table__actions {
  white-space: nowrap;
}

.subadmin-table__actions .btn-icon {
  margin: 0 2px;
}

.btn-icon {
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: var(--radius);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.85rem;
  transition: transform 0.15s, background 0.15s;
}

.btn-icon:hover {
  transform: scale(1.08);
}

.btn-icon--view {
  background: #dbeafe;
  color: #0f766e;
}

.btn-icon--view:hover {
  background: #bfdbfe;
}

.btn-icon--edit {
  background: #fef3c7;
  color: #b45309;
}

.btn-icon--edit:hover {
  background: #fde68a;
}

.btn-icon--block {
  background: #fee2e2;
  color: #b91c1c;
}

.btn-icon--block:hover {
  background: #fecaca;
}

.btn-icon--unblock {
  background: #dcfce7;
  color: #15803d;
}

.btn-icon--unblock:hover {
  background: #bbf7d0;
}

.btn-icon--delete {
  background: #fef2f2;
  color: #b91c1c;
}

.btn-icon--delete:hover {
  background: #fecaca;
}

/* View modal: detail list */
.modal--md {
  max-width: 480px;
}

.detail-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.detail-list__row {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 0.6rem 0;
  border-bottom: 1px solid var(--border);
}

.detail-list__row:last-of-type {
  border-bottom: none;
}

.detail-list dt {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-muted);
  min-width: 80px;
  flex-shrink: 0;
}

.detail-list dd {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Admin/SubAdminPage.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* Sub Admin: full-width list */\n.dashboard-body .dashboard-activity-section {\n  width: 100%;\n  min-width: 0;\n}\n\n.dashboard-body .dashboard-content-inner {\n  width: 100%;\n  min-width: 0;\n}\n\n.dashboard-body .table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.dashboard-body .data-table {\n  width: 100%;\n  min-width: 600px;\n  table-layout: auto;\n}\n\n/* Sub Admin: header with action button */\n.dashboard-activity-header--with-action {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.dashboard-activity-header__left {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n/* Buttons */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  font-family: inherit;\n  border: none;\n  border-radius: var(--radius);\n  cursor: pointer;\n  transition: background 0.2s, opacity 0.2s;\n}\n\n.btn i {\n  font-size: 0.8rem;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n}\n\n.btn-primary:hover {\n  opacity: 0.95;\n}\n\n.btn-secondary {\n  background: var(--main-bg);\n  color: var(--text);\n  border: 1px solid var(--border);\n}\n\n.btn-secondary:hover {\n  background: var(--border);\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  animation: modalFadeIn 0.2s ease;\n}\n\n@keyframes modalFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.modal {\n  background: var(--card-bg);\n  border-radius: var(--radius);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  width: 100%;\n  max-width: 440px;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: modalSlideIn 0.25s ease;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-16px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid var(--border);\n}\n\n.modal-title {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.modal-close {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: var(--radius);\n  background: transparent;\n  color: var(--text-muted);\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n\n.modal-close:hover {\n  background: var(--main-bg);\n  color: var(--text);\n}\n\n.modal-body {\n  padding: 1.5rem;\n  overflow-y: auto;\n}\n\n.modal-error {\n  padding: 0.65rem 1rem;\n  margin-bottom: 1rem;\n  font-size: 0.85rem;\n  color: #b91c1c;\n  background: #fef2f2;\n  border-radius: var(--radius);\n}\n\n.modal-field {\n  margin-bottom: 1rem;\n}\n\n.modal-field label {\n  display: block;\n  margin-bottom: 0.35rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text);\n}\n\n.modal-field input,\n.modal-field select {\n  width: 100%;\n  padding: 0.65rem 1rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: #fff;\n  color: var(--text);\n}\n\n.modal-field input:focus,\n.modal-field select:focus {\n  outline: none;\n  border-color: #14b8a6;\n}\n\n/* Multiple roles: checkboxes */\n.roles-checkbox-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 1.25rem;\n  padding: 0.75rem 0;\n}\n\n.roles-checkbox-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--text);\n  cursor: pointer;\n  user-select: none;\n}\n\n.roles-checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #0f766e;\n  cursor: pointer;\n}\n\n.subadmin-table__roles {\n  max-width: 220px;\n  font-size: 0.875rem;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 1.25rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border);\n}\n\n.modal-footer .btn {\n  min-width: 100px;\n}\n\n/* Sub Admin table: action buttons */\n.subadmin-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.subadmin-table__actions {\n  white-space: nowrap;\n}\n\n.subadmin-table__actions .btn-icon {\n  margin: 0 2px;\n}\n\n.btn-icon {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: var(--radius);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: transform 0.15s, background 0.15s;\n}\n\n.btn-icon:hover {\n  transform: scale(1.08);\n}\n\n.btn-icon--view {\n  background: #dbeafe;\n  color: #0f766e;\n}\n\n.btn-icon--view:hover {\n  background: #bfdbfe;\n}\n\n.btn-icon--edit {\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.btn-icon--edit:hover {\n  background: #fde68a;\n}\n\n.btn-icon--block {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.btn-icon--block:hover {\n  background: #fecaca;\n}\n\n.btn-icon--unblock {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.btn-icon--unblock:hover {\n  background: #bbf7d0;\n}\n\n.btn-icon--delete {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.btn-icon--delete:hover {\n  background: #fecaca;\n}\n\n/* View modal: detail list */\n.modal--md {\n  max-width: 480px;\n}\n\n.detail-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.detail-list__row {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 0.6rem 0;\n  border-bottom: 1px solid var(--border);\n}\n\n.detail-list__row:last-of-type {\n  border-bottom: none;\n}\n\n.detail-list dt {\n  margin: 0;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--text-muted);\n  min-width: 80px;\n  flex-shrink: 0;\n}\n\n.detail-list dd {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
